/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AptosChainInfo } from '../models/AptosChainInfo';
import type { AptosGeneralInfo } from '../models/AptosGeneralInfo';
import type { AptosGeneralRequest } from '../models/AptosGeneralRequest';
import type { AptosGeneralSummaryInfo } from '../models/AptosGeneralSummaryInfo';
import type { BabylonGeneralInfo } from '../models/BabylonGeneralInfo';
import type { BabylonGeneralRequest } from '../models/BabylonGeneralRequest';
import type { BabylonGeneralSummaryInfo } from '../models/BabylonGeneralSummaryInfo';
import type { CommonEmptyRequest } from '../models/CommonEmptyRequest';
import type { EvmGeneralInfo } from '../models/EvmGeneralInfo';
import type { EvmGeneralRequest } from '../models/EvmGeneralRequest';
import type { EvmGeneralSummaryInfo } from '../models/EvmGeneralSummaryInfo';
import type { HumanityGeneralInfo } from '../models/HumanityGeneralInfo';
import type { HumanityGeneralRequest } from '../models/HumanityGeneralRequest';
import type { HumanityGeneralSummaryInfo } from '../models/HumanityGeneralSummaryInfo';
import type { KiteGeneralInfo } from '../models/KiteGeneralInfo';
import type { KiteGeneralRequest } from '../models/KiteGeneralRequest';
import type { KiteGeneralSummaryInfo } from '../models/KiteGeneralSummaryInfo';
import type { SomniaGeneralInfo } from '../models/SomniaGeneralInfo';
import type { SomniaGeneralRequest } from '../models/SomniaGeneralRequest';
import type { ZerogGeneralInfo } from '../models/ZerogGeneralInfo';
import type { ZerogGeneralRequest } from '../models/ZerogGeneralRequest';
import type { ZerogGeneralSummaryInfo } from '../models/ZerogGeneralSummaryInfo';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class GeneralControllerService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getHomeGeneral({
        requestBody,
    }: {
        requestBody: (AptosGeneralRequest | EvmGeneralRequest | HumanityGeneralRequest | KiteGeneralRequest | SomniaGeneralRequest | BabylonGeneralRequest | ZerogGeneralRequest),
    }): CancelablePromise<(AptosGeneralInfo | EvmGeneralInfo | HumanityGeneralInfo | KiteGeneralInfo | SomniaGeneralInfo | BabylonGeneralInfo | ZerogGeneralInfo)> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/general',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getHomeGeneralSummary(): CancelablePromise<(AptosGeneralSummaryInfo | EvmGeneralSummaryInfo | HumanityGeneralSummaryInfo | KiteGeneralSummaryInfo | BabylonGeneralSummaryInfo | ZerogGeneralSummaryInfo)> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/general/summary',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getChainInfo({
        requestBody,
    }: {
        requestBody: CommonEmptyRequest,
    }): CancelablePromise<AptosChainInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/general/chain',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
